// extracted by mini-css-extract-plugin
module.exports = {"root":"VisuallyHidden_root__1ybal"};